module.exports = __webpack_public_path__ + "static/media/pp.0fa40943.png";